__webpack_require__.p = "/schedule/";